import { render, staticRenderFns } from "./ChatContextItem.vue?vue&type=template&id=1f7c286a&scoped=true"
import script from "./ChatContextItem.vue?vue&type=script&lang=js"
export * from "./ChatContextItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7c286a",
  null
  
)

export default component.exports